import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import Layout from '../../Layout/Layout';
import { useTranslator } from '@front-activerse/common-components';
import ExternalProviderContainer from '../../Auth/ExternalProvider/ExternalProviderContainer';
import { useState } from 'react';
import SignupAndActivateProductForm from './SignupAndActivateProductForm';
import ActiveProductLoginContainer from '../Login/ActiveProductLoginContainer';

type tabType = 'signup' | 'login';

interface ISignupAndActivateProductContainer {
  registerAndActivateCoupon: (request: any) => Promise<unknown>;
  userDataOnDemand: () => Promise<unknown>;
  pathActiveProduct: string;
  displayAppleButton: boolean;
  displayFacebookButton: boolean;
  displayGoogleButton: boolean;
}

const SignupAndActivateProductContainer: React.FC<ISignupAndActivateProductContainer> = ({
  registerAndActivateCoupon,
  userDataOnDemand,
  pathActiveProduct,
  displayAppleButton,
  displayFacebookButton,
  displayGoogleButton,
}) => {
  const { t } = useTranslator();
  const [activeTab, setActiveTab] = useState<tabType>('signup');

  global.localStorage.setItem('redirectToPathAfterSuccess', pathActiveProduct);

  const toggle = (tab: tabType) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <Layout simpleLayout>
      <div className="page-template-auth full-height7">
        <Container className="py-xxl">
          <Row>
            <Col
              xs={12}
              md={{ size: 8, offset: 2 }}
              xl={{ size: 6, offset: 3 }}
              xxl={{ size: 4, offset: 4 }}
            >
              <h1 className="text-center title-medium semi-bold mb-xl">
                {t('couponActivation.title')}
              </h1>

              <div className="page-container mb-xl">
                <Nav tabs>
                  <NavItem
                    className={
                      activeTab === 'signup' ? 'active w-50 text-center' : 'w-50 text-center'
                    }
                    onClick={() => {
                      toggle('signup');
                    }}
                  >
                    <NavLink>{t('signUp.title')}</NavLink>
                  </NavItem>
                  <NavItem
                    className={
                      activeTab === 'login' ? 'active w-50 text-center' : 'w-50 text-center'
                    }
                    onClick={() => {
                      toggle('login');
                    }}
                  >
                    <NavLink>{t('logIn.title')}</NavLink>
                  </NavItem>
                </Nav>
                <div className="auth-container">
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="signup">
                      <ExternalProviderContainer
                        returnUrl="RETURN_URL_ACTIVATE"
                        action="activate_product_register"
                        displayAppleButton={displayAppleButton}
                        displayFacebookButton={false}
                        displayGoogleButton={displayGoogleButton}
                        socialBtnClassName="w-100"
                      />
                      {(displayAppleButton || displayFacebookButton || displayGoogleButton) && (
                        <div className="line">
                          <span>{t('authorization.continueWithEmail.description')}</span>
                        </div>
                      )}
                      <SignupAndActivateProductForm
                        registerAndActivateCoupon={registerAndActivateCoupon}
                        userDataOnDemand={userDataOnDemand}
                      />
                    </TabPane>
                    <TabPane tabId="login">
                      <ExternalProviderContainer
                        returnUrl="RETURN_URL_LOGIN"
                        action=""
                        displayAppleButton={displayAppleButton}
                        displayFacebookButton={displayFacebookButton}
                        displayGoogleButton={displayGoogleButton}
                        socialBtnClassName="w-100"
                      />
                      {(displayAppleButton || displayFacebookButton || displayGoogleButton) && (
                        <div className="line">
                          <span>{t('authorization.continueWithEmail.description')}</span>
                        </div>
                      )}
                      <ActiveProductLoginContainer pathActiveProduct={pathActiveProduct} />
                    </TabPane>
                  </TabContent>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export default SignupAndActivateProductContainer;
